import { create } from "zustand";

export type CNumber = {
  dmsUserId: string;
  cNumber: string;
  value?: string;
  label?: string;
  alias?:string,
  cnumber?:string // LIKWYT: but EIS standard
};

export interface DriveState {
  cNumbers: any[];
  setCNumbers: (cNumbers:CNumber[]) => void;
  dmsMapping: CNumber[];
  setDMSBoxMapping: (dmsMapping:any) => void;
  isFetched: boolean;
  setIsFetched: (isFetched:boolean) => void;
}

export const useDriveStore = create<DriveState>((set) => ({
 cNumbers: [],
 dmsMapping: [],
 setCNumbers: (cNumbers) => set(() => ({ cNumbers })),
 isFetched: false,
 setDMSBoxMapping: (dmsMapping) => set(() => ({ dmsMapping })),
 setIsFetched: (isFetched) => set(() => ({ isFetched }))
}));